import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nextjs/app/_components/AnalyticsVariablesSetter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CampusCookieWrapperClient"] */ "/app/nextjs/app/_components/contexts/CampusCookieContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientSourceTrackingWrapperClient"] */ "/app/nextjs/app/_components/contexts/ClientSourceTrackingContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactFormProvider"] */ "/app/nextjs/app/_components/contexts/ContactFormContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserInfoWrapperClient"] */ "/app/nextjs/app/_components/contexts/userInfoContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nextjs/app/_components/Cro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nextjs/app/_components/FrontendObservabilityDynamicWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nextjs/app/_components/layout/AdminCampusSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nextjs/app/_components/OsanoConsentManagement.tsx");
;
import(/* webpackMode: "eager" */ "/app/nextjs/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/nextjs/app/form-globals.css");
;
import(/* webpackMode: "eager" */ "/app/nextjs/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/app/nextjs/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/nextjs/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/nextjs/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/nextjs/node_modules/jotai/esm/react.mjs");
;
import(/* webpackMode: "eager" */ "/app/nextjs/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/nextjs/node_modules/next/font/google/target.css?{\"path\":\"app/font-setup.ts\",\"import\":\"Roboto_Flex\",\"arguments\":[{\"subsets\":[\"latin\"],\"axes\":[\"wdth\",\"YOPQ\",\"YTUC\",\"YTFI\",\"opsz\"],\"variable\":\"--font-roboto-flex\"}],\"variableName\":\"robotoFlexGoogleFont\"}");
;
import(/* webpackMode: "eager" */ "/app/nextjs/node_modules/next/font/google/target.css?{\"path\":\"app/font-setup.ts\",\"import\":\"PT_Serif\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"],\"variable\":\"--font-pt-serif\"}],\"variableName\":\"ptSerifGoogleFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/nextjs/node_modules/react-error-boundary/dist/react-error-boundary.esm.js");
;
import(/* webpackMode: "eager" */ "/app/nextjs/public/pizza-shapes/arch.svg");
